import { ref } from 'vue';
import Request from '@/services/request';
import { EARLY_SETTLEMENT_CONTRACT } from '@/utils/enum/endpoints';

const Req = new Request();

export default function useEarlySettlementContract() {
  const data = ref('');
  const error = ref(null);
  const isLoading = ref(false);

  const fetchContract = async () => {
    isLoading.value = true;
    error.value = null;
    try {
      const response = await Req.get(EARLY_SETTLEMENT_CONTRACT, null, {
        baseURL: '/sellerofficeapi/rest',
        headers: { 
          Accept: 'text/html',
          'Content-Type': 'text/html;charset=utf-8'
        },
      });
      if (response.status === 200) {
        data.value = response.data;
        error.value = null;
      } else {
        throw new Error('Network response was not OK');
      }
    } catch (err) {
      error.value = err || null;
      data.value = '';
    } finally {
      isLoading.value = false;
    }
  };

  return {
    data,
    error,
    isLoading,
    fetchContract,
  };
}

